import { USER_DATA_CONSTANT } from "app/_constants/Redux/userData.constant";
import { CallApi } from "app/_helpers/CallApi/CallApi";
import configureStore from "../../redux/Store";
import { clearContractorStore } from "app/_pages/UserManagement/UserRegistration/helper";
let { Store } = configureStore();

export async function getContractor(filter) {
  let url = "/user-management/contractor" + (filter ? `?${filter}` : "");
  return await CallApi(url, "GET");
}

export async function getContractorByID(id) {
  let url = "/user-management/contractor/" + id;
  return await CallApi(url, "GET");
}

export async function createContractor(data) {
  let url = "/user-management/contractor";
  const response = await CallApi(url, "POST", data);
  if (response?.status) {
    clearContractorStore();
  }
  return response;
}

export const addContractorExcel = async (data) => {
  let url = "/user-management/contractor/save-excel-data";
  return await CallApi(url, "POST", data);
};

export async function uploadContractorByExcel(data) {
  let url = "/user-management/contractor/upload-excel";
  return await CallApi(url, "POST", data);
}

export async function downloadContractorExcel() {
  let url = "/user-management/contractor/download-excel";
  return await CallApi(url, "GET");
}

export async function updateContractor(id, data) {
  let url = "/user-management/contractor/" + id;
  const response = await CallApi(url, "PUT", data);
  if (response?.status) {
    clearContractorStore();
  }
  return response;
}

export async function deleteContractor(id, data) {
  let url = "/user-management/contractor/" + id;
  return await CallApi(url, "DELETE", data);
}

export const updateContractorHistory = async (data) => {
  let url = "/user-management/contractor-site-history";
  return await CallApi(url, "POST", data);
};

export async function getActiveContractor(filter) {
  let url = "/user-management/active-contractor-list" + (filter ? `?${filter}` : "");
  return await CallApi(url, "GET");
}

export async function updateReleaseContractor(id, data) {
  let url = "/user-management/contractor-release-from-mine/" + id;
  return await CallApi(url, "PUT", data);
}

export async function getContractorForOtherModuel() {
  const resultData = Store.getState()?.userManagement?.contractorForOthrModuel;
  if (Array.isArray(resultData) && resultData?.length) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          status: 1,
          message: "Data from Store",
          data: resultData,
        });
      }, 0);
    });
  } else {
    let url = "/user-management/contractor-for-other-moduel";
    let response = await CallApi(url, "GET");
    Store.dispatch({
      type: USER_DATA_CONSTANT.CONTRACTOR_FOR_OTHER_MODUEL,
      data: response?.data,
    });
    return response;
  }
}
